<template>
  <b-form-group :label="label"
                :invalid-feedback="errorTxt"
                :state="state">
    <div class="bs-component">
      <ul class="list-group">
        <li v-if="inputVal" class="list-group-item">
          <div class="row">
            <div class="col-3">{{ $t('publicIp') }}</div>
            <div class="col-3">{{ $t('localIp') }}</div>
            <div class="col-2 text-center">{{ $t('weight') }}</div>
            <div class="col-2 text-right">{{ $t('default') }}</div>
            <div class="col-2 text-right"></div>
          </div>
        </li>
        <draggable v-if="inputVal && inputVal.length" v-model="inputVal" tag="div">
          <li class="list-group-item" v-for="(item, index) in inputVal" :key="'op'+index">
            <div class="row">
              <div class="col-3">
                <input class="form-control" v-model="item.publicIp" :placeholder="$t('publicIp')" />
              </div>
              <div class="col-3">
                <input class="form-control" v-model="item.localIp" :placeholder="$t('localIp')" />
              </div>
              <div class="col-2 text-center">
                <input class="form-control text-center" v-model="item.weight" :placeholder="$t('weight')" />
              </div>
              <div class="col-2 text-right" @click="defaultChange(index)">
                <i v-if="item.default" class="fa fa-check-square"></i>
                <i v-else class="fa fa-square"></i>
              </div>
              <div class="col-2 text-right">
                <button @click="removeItem(index)" type="button" class="btn btn-sm btn-danger mr-1">
                  <font-awesome-icon icon="trash"/>
                </button>
              </div>
            </div>
          </li>
        </draggable>
        <li class="list-group-item">
          <div class="row">
            <div class="col-3">
              <input class="form-control" v-model="newItem.publicIp" :placeholder="$t('publicIp')"
                     v-on:keyup="newItemEnter"/>
            </div>
            <div class="col-3">
              <input class="form-control" v-model="newItem.localIp" :placeholder="$t('localIp')"
                     v-on:keyup="newItemEnter"/>
            </div>
            <div class="col-2 text-center">
              <input class="form-control text-center" v-model="newItem.weight" :placeholder="$t('weight')"
                     v-on:keyup="newItemEnter"/>
            </div>
            <div class="col-2 text-right">
<!--              <b-checkbox v-model="df"></b-checkbox>-->
            </div>
            <div class="col-2 text-right">
              <button type="button" class="btn btn-sm btn-primary" @click="addNewItem">{{ $t('create') }}</button>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </b-form-group>
</template>

<script>
import draggable from 'vuedraggable';

export default {
  components: {draggable},
  props: ['model', 'attribute', 'label', 'type', 'placeholder', 'errors', 'readonly', 'errorOnly'],
  data() {
    return {
      inputVal: this.model[this.attribute] ? this.model[this.attribute] : null,
      state: null,
      errorTxt: '',
      newItem: {
        publicIp: null,
        localIp: null,
        weight: 1,
        default: false
      },
      df: false
    }
  },
  watch: {
    model: {
      handler(val) {
        this.state = null;
        this.errorTxt = '';
        this.inputVal = val[this.attribute];
      }, deep: true
    },
    inputVal(val) {
      this.state = null;
      this.errorTxt = '';
      this.model[this.attribute] = val;
    },
    errors(val) {
      let hasErr = false;
      if (val.length) {
        val.forEach(v => {
          if (v.param === this.attribute) {
            this.state = false;
            this.errorTxt = v.msg;
            hasErr = true;
            return;
          }
        });
      }
      if (!this.errorOnly) {
        this.state = !hasErr;
      }
    }
  },
  methods: {
    defaultChange(index) {
      for (let i in this.inputVal) {
        let model = this.inputVal[i];
        if (i != index) {
          model.default = false;
        } else {
          model.default = true;
        }
      }
    },
    updateItem: function (key) {
      if (this.model[this.attribute][key]) {
        let model = this.model[this.attribute];
        model[key] = this.inputVal[key];

        this.model[this.attribute] = null;
        this.model[this.attribute] = model;
      }
    },
    addNewItem: function () {
      let model = this.model[this.attribute];
      if (model == null) {
        model = [];
      }
      if (this.newItem && this.newItem.publicIp && this.newItem.localIp) {
        this.newItem.default = model && model.length === 0;
        this.newItem.weight = this.newItem.weight ? this.newItem.weight : 1
        model.push(this.newItem);
        this.newItem = {
          publicIp: null,
          localIp: null,
          weight: 1,
          default: false
        };
      }
      this.model[this.attribute] = null;
      this.model[this.attribute] = model;
    },
    newItemEnter: function (e) {
      if (e.keyCode === 13) {
        this.addNewItem();
      }
    },
    removeItem: function (index) {
      if (this.model[this.attribute] && this.model[this.attribute].length) {
        this.model[this.attribute].splice(index, 1);
      }
    }
  },
  i18n: {
    messages: {
      en: {
        publicIp: 'Public IP',
        localIp: 'Local IP',
        default: "Default",
        weight: 'Weight'
      },
      vi: {
        publicIp: 'Public IP',
        localIp: 'Local IP',
        default: "Mặc định",
        weight: 'Trọng số'
      }
    }
  },
}
</script>